<template>
  <div id="app">
    <transition name="show-from-left">
        <popover name="helptop" :width="240">
            <Help :titleChart="titleChart">
            <div slot="content">
              <p> {{ $t("277") }} </p>
            </div>
          </Help>
        </popover>
    </transition>
    <div v-show='!showOtherChart'>
        <div class="title-charts title-bt-help">{{ $t("278") }}
          <button class="bt-help" v-popover:helptop.bottom><i class="icon-help ti-help-alt"></i></button>
        </div>

        <transition name="fade">
          <highcharts :options="chartOptions" ref='chart' ></highcharts>
        </transition>
    </div>

    <transition name="fade">
      <ChartsAlarme v-show='showOtherChart'></ChartsAlarme>
    </transition>

   <!--  <div id='buttons' class="btn-group btn-group-sm" role="group" aria-label="Buttons">
      <button type="button" class="btn btn-secondary" @click="getOtherChart()"><small>{{ btn_title }}</small></button>
    </div> -->
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import Vue from 'vue'
import axios from 'axios';
import mixin from '../../../../utils/mixin'

import ChartsAlarme from 'src/components/Dashboard/Views/ChartsOnline/ChartsAlarme'

import Popover  from 'vue-js-popover'
Vue.use(Popover)
import Help from 'src/components/Dashboard/Views/components/Help'

export default {
  name: 'charts',
  components: {
    ChartsAlarme,
    Help
  },
  data () {
    return {
        titleChart: this.$t("279"),
        tableData: [],
        chartOptions: {
        colors: ['#8b3d88', '#90ed7d', '#e4d354', '#f45b5b', '#6b91c9', '#3e9b80', '#3257a8', '#dd6b7f', '#0984e3', '#ffeaa7', '#e84393', '#55efc4', '#636e72', '#ff7675', '#f1c40f', '#34495e'],
        chart: {
          type: 'column',
          backgroundColor: 'rgba(0,0,0,0)',
          style: {
            fontFamily: '\'Unica One\', sans-serif'
          },
          plotBorderColor: '#606063'
        },
        title: {
            text: '',
            style: {
                color: '#E0E0E3',
                textTransform: 'uppercase',
                fontSize: '16px',
                fontWeight: 'bold'
            }
        },
        subtitle: {
            style: {
                color: '#E0E0E3',
                textTransform: 'uppercase'
            }
        },
        xAxis: {
            categories: [],
            crosshair: true,
            gridLineColor: '#707073',
            labels: {
                style: {
                    color: '#E0E0E3'
                }
            },
            lineColor: '#707073',
            minorGridLineColor: '#505053',
            tickColor: '#707073',
            title: {
                style: {
                    color: '#A0A0A3'
                }
            }
        },
        yAxis: {
            min: 0,
            title: {
                text: this.$t("131"),
                style: {
                    color: '#A0A0A3'
                }
            },
            gridLineColor: '#707073',
            labels: {
                style: {
                    color: '#E0E0E3'
                }
            },
            lineColor: '#707073',
            minorGridLineColor: '#505053',
            tickColor: '#707073',
            tickWidth: 1,
            allowDecimals: false,
        },
        tooltip: {
            backgroundColor: 'rgba(0, 0, 0, 0.85)',
            style: {
                color: '#F0F0F0'
            },
            headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
            pointFormat: '<tr><td style="color:{series.color};padding:0">'+ this.$t("136") +': </td>' +
                '<td style="padding:0;"><b>{point.y}</b></td></tr>',
            footerFormat: '</table>',
            shared: true,
            useHTML: true
        },
        plotOptions: {
            series: {
                dataLabels: {
                    enabled: true,
                    color: '#F0F0F3',
                    style: {
                        fontSize: '13px'
                    }

                },
                marker: {
                    lineColor: '#333'
                },
                events: {
                    click: this.loadGrid
                },
                cursor: 'pointer'
            },
            column: {
                pointPadding: 0.1,
                borderWidth: 0,
            }
        },
        legend: {
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            itemStyle: {
                color: '#E0E0E3'
            },
            itemHoverStyle: {
                color: '#FFF'
            },
            itemHiddenStyle: {
                color: '#606063'
            },
            title: {
                style: {
                    color: '#C0C0C0',
                    fontSize: '12px'
                }
            },
            enabled: false
        },
        labels: {
            style: {
                color: '#707073'
            }
        },
        drilldown: {
            activeAxisLabelStyle: {
                color: '#F0F0F3'
            },
            activeDataLabelStyle: {
                color: '#F0F0F3'
            }
        },
        navigation: {
            buttonOptions: {
                symbolStroke: '#DDDDDD',
                theme: {
                    fill: '#505053'
                }
            }
        },
        // scroll charts
        rangeSelector: {
            buttonTheme: {
                fill: '#505053',
                stroke: '#000000',
                style: {
                    color: '#CCC'
                },
                states: {
                    hover: {
                        fill: '#707073',
                        stroke: '#000000',
                        style: {
                            color: 'white'
                        }
                    },
                    select: {
                        fill: '#000003',
                        stroke: '#000000',
                        style: {
                            color: 'white'
                        }
                    }
                }
            },
            inputBoxBorderColor: '#505053',
            inputStyle: {
                backgroundColor: '#333',
                color: 'silver'
            },
            labelStyle: {
                color: 'silver'
            }
        },
        navigator: {
            handles: {
                backgroundColor: '#666',
                borderColor: '#AAA'
            },
            outlineColor: '#CCC',
            maskFill: 'rgba(255,255,255,0.1)',
            series: {
                color: '#7798BF',
                lineColor: '#A6C7ED'
            },
            xAxis: {
                gridLineColor: '#505053'
            }
        },
        scrollbar: {
            barBackgroundColor: '#808083',
            barBorderColor: '#808083',
            buttonArrowColor: '#CCC',
            buttonBackgroundColor: '#606063',
            buttonBorderColor: '#606063',
            rifleColor: '#FFF',
            trackBackgroundColor: '#404043',
            trackBorderColor: '#404043'
        },
        series: [{color: '#F45B5B'}],
        exporting: { enabled: false },
        credits: {
          enabled: false
        },
        loading: {
            labelStyle: {
                color: 'black',
                textShadow: '1px 0 0 #fff, -1px 0 0 #fff, 0 1px 0 #fff, 0 -1px 0 #fff, 1px 1px #fff, -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff',
            },
            style: {
                backgroundColor: 'none',
                opacity: 1,
            }
        },

      },//fim chartOptions
      showOtherChart: false,
      activeOtherChart: false,
      btn_title: 'POINT ALARME'
    }
  },
  mixins: [mixin],
  methods: {
    ...mapMutations(['changeGridOnline']),

    loadGrid(event){

        let id = event.point.category; // equip_id

        let point_name = event.point.category
        let NAME_CHART = this.$t("374") + ' - ' + point_name.toUpperCase()

        const ENDPOINT = `v1/mysemeq-ambev/get-top-priorities-grid?corp=${this.filtersOn.corp}&region=${this.filtersOn.region}&planta=${this.filtersOn.planta}&id=${id}&area_f=${this.filtersOn.area_f}&sector_f=${this.filtersOn.sector_f}&machine=${this.filtersOn.machine}&subset=${this.filtersOn.subset}`

        let grid = {
        title: this.$t("374"),
        url: ENDPOINT,
        name_chart: NAME_CHART,
        columns: {
            "area": [this.$t("311")],
            "setor": [this.$t("312")],
            "conj": [this.$t("316"), 'conjunto'],
            "conj_tag": [this.$t("317")],
            "equip": [this.$t("313")],
            "equip_tag": [this.$t("314")],
            "status": ['Status'],
            "rdps": [this.$t("161")],
            "approved_datetime": [this.$t("320")]
            },
        show: true,
        export_csv: false,
        titleHelp: 'Grid - ' + this.$t("374"),
        txtHelp: this.$t("375")
        }

        if (!this.filtersOn.planta) {
            grid.columns = {"rows": [''], 'planta': [this.$t("310"), 'planta_f'], ...grid.columns}
        }
        else{
            grid.columns = {"rows": [''],  ...grid.columns}
        }

        if (this.filtersOn.plant) {
            grid.title += ' - ' + this.filtersOn.plant_name
            // delete grid.columns['plant']
        } else if (this.filtersOn.region){
            grid.title += ' - ' + this.filtersOn.region
        }

        this.changeGridOnline(grid);
    },

    getData(){

      const API = process.env.ROOT_API;
      const ENDPOINT = `v1/mysemeq-ambev/get-top-priorities?corp=${this.filtersOn.corp}&region=${this.filtersOn.region}&planta=${this.filtersOn.planta}&area_f=${this.filtersOn.area_f}&sector_f=${this.filtersOn.sector_f}&machine=${this.filtersOn.machine}&subset=${this.filtersOn.subset}`
      this.$refs.chart.chart.showLoading();

      let self = this;
      axios({method: 'GET', url: API + ENDPOINT, headers: { Authorization: `Bearer ${localStorage.getItem('user-token')}` }})
      .then(({ data })=> {
        self.chartOptions.xAxis.categories = data.x;
        self.chartOptions.series[0].data = data.y;

        self.$refs.chart.chart.hideLoading();
      })
      .catch(err => {
        // from mixin
        self.ApiErrorHandler(self, error.response.data.status_code);
        self.$refs.chart.chart.showLoading('Error');
      })

    },
    getOtherChart () {
      this.showOtherChart = !this.showOtherChart;
      this.activeOtherChart = !this.activeOtherChart;
      this.btn_title = this.showOtherChart ? 'Top Priorities' : 'Point Alarm'
    }
  },
  computed: {
    ...mapGetters(['filtersOn']),
  },
  watch: {
    filtersOn: function(newValue){
        this.getData();
    },
  },
}
</script>
<style scoped>
tspan {
    /*fill: #fff;*/
    stroke: none!important;
    stroke-width: 1px;
    stroke-linejoin: round;
    /*color: #fff;*/
   /* font-weight: normal;
    font-size: 14px;*/
}
.highcharts-drilldown-data-label text{
  text-decoration:none !important;
}

/*css button other chart (point alarm)*/
#buttons{
  position: absolute;
  left: 60px;
  top: -10px;
  z-index: 25;
  height: 20px;
  align-items: center;
}

.btn{
  background-color: #000;
  color: #66615b;
  font-weight: 800;
}

.activeOtherChart{
  background-color: #66615b !important;
  color: #eee!important;
}


.fade-enter-active {
  transition: opacity .8s;
}

.fade-leave-active {
  display: none;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}
/*fim - css button other chart (point alarm)*/
#buttons{
    top: -5px!important;
    left: 0px !important;
}

div[data-popover="helptop"] {
  left: 36% !important;
  top: 6% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/ChartsOnline/PrioritiesChart.vue